<!--
  @Description: 购票
  @Author: wang.y 
  @Date: 2024-07-27 
-->
<template>
  <div>
    <div class="skeleton-warpper" v-if="pageLoading">
      <van-skeleton title :row="5" />
    </div>
    <div class="main-container" v-else>
      <page-header v-if="$route.name != 'offline'">
        {{ '预注册' | dealLanguage('Pre-registration') }}
      </page-header>
      <page-header v-else>
        {{ 'CSGCT现场报名' | dealLanguage('CSGCT On-site Registration') }}
      </page-header>
      <div class="center-wrapper">
        <TopTip v-if="$route.name != 'offline'"></TopTip>
        <div class="form-view">
          <Form ref="current-form" :model="currentForm" :rules="ruleValidate2">
            <div class="view-title">
              <div class="title">
                {{ '个人信息' | dealLanguage('Personal Information') }}
              </div>
              <div class="line"></div>
            </div>
            <FormItem prop="name" :label="'姓名' | dealLanguage('Name')">
              <Input
                type="text"
                v-model="currentForm.name"
                :placeholder="
                  '请填写姓名' | dealLanguage('Please fill in your name')
                "
              ></Input>
            </FormItem>
            <template v-if="language == 'zh'">
              <FormItem prop="mobile" label="手机号码">
                <div class="mobile-ipt">
                  <span
                    :class="['area-number']"
                    :style="isVerifyCode ? 'background-color: #f0f0f0;' : ''"
                    @click="handleShowPicker"
                    >+{{ currentForm.mobileAreaCode }} &gt;</span
                  >
                  <Input
                    type="text"
                    class="right-padding"
                    v-model="currentForm.mobile"
                    :disabled="isVerifyCode"
                    placeholder="请输入手机号"
                    autocomplete="off"
                  ></Input>
                  <Captcha
                    ref="captcha"
                    scene="vbdata_loginon"
                    :mobile="currentForm.mobile"
                    :mobileAreaCode="currentForm.mobileAreaCode"
                    v-if="!isVerifyCode"
                    captchaButtonId="sign-captcha-button"
                    captchaElementId="sign-captcha-element"
                  ></Captcha>
                  <Button
                    type="text"
                    class="code-btn"
                    v-else
                    @click="handleUpdateMobile"
                    >更新手机号</Button
                  >
                </div>
              </FormItem>
              <FormItem prop="verifyCode" label="验证码">
                <Input
                  type="text"
                  v-model="currentForm.verifyCode"
                  :disabled="isVerifyCode"
                  placeholder="请填写验证码"
                ></Input>
                <div class="verify-success" v-if="isVerifyCode">
                  <i class="iconfont">&#xe71d;</i>
                  <span>验证成功</span>
                </div>
              </FormItem>
              <FormItem prop="email" label="E-mail">
                <Input
                  type="text"
                  v-model="currentForm.email"
                  placeholder="请填写邮箱"
                ></Input>
              </FormItem>
            </template>
            <template v-else>
              <FormItem prop="email" label="E-mail">
                <Input
                  type="text"
                  class="right-padding"
                  :disabled="isVerifyCode"
                  v-model="currentForm.email"
                  placeholder="Please fill in your email"
                ></Input>
                <Captcha
                  ref="captcha"
                  validMode="2"
                  scene="vbdata_loginon"
                  :email="currentForm.email"
                  v-if="!isVerifyCode"
                  captchaButtonId="sign-email-captcha-button"
                  captchaElementId="sign-email-captcha-element"
                ></Captcha>
                <Button
                  type="text"
                  class="code-btn"
                  v-else
                  @click="handleUpdateMobile"
                  >Update E-mail</Button
                >
              </FormItem>
              <FormItem prop="verifyCode" label="E-mail Verification Code">
                <Input
                  type="text"
                  v-model="currentForm.verifyCode"
                  :disabled="isVerifyCode"
                  placeholder="Please enter the verification code"
                ></Input>
                <div class="verify-success" v-if="isVerifyCode">
                  <i class="iconfont">&#xe71d;</i>
                  <span>Verification successful</span>
                </div>
              </FormItem>
              <FormItem prop="enmobile" label="Mobile Number">
                <Input
                  type="text"
                  v-model="currentForm.enmobile"
                  placeholder="Please enter your mobile number"
                  autocomplete="off"
                ></Input>
              </FormItem>
            </template>
            <Row :gutter="10">
              <Col span="12">
                <FormItem
                  prop="compName"
                  :label="'公司' | dealLanguage('Company Name')"
                >
                  <div class="input-tag">
                    <AutoComplete
                      v-model="entityKeyword"
                      :placeholder="
                        !currentForm.entityId
                          ? filter.dealLanguage(
                              '请搜索并选择公司',
                              'Please search and select a company',
                            )
                          : ''
                      "
                      @on-search="handleSearchEntity"
                      @on-select="handleSelectEntity"
                      @on-change="handleChangeEntity"
                    >
                      <Option
                        v-for="item in entityList"
                        :value="item.id"
                        :key="item.id"
                      >
                        <div class="title">
                          {{ item.shortName }}
                        </div>
                        <div class="desc">
                          {{ item.description }}
                        </div>
                      </Option>
                    </AutoComplete>
                    <div class="tag-div" v-if="currentForm.entityId">
                      <Tag closable @on-close="handleClose" color="blue">{{
                        currentForm.compName
                      }}</Tag>
                    </div>
                  </div>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem
                  prop="title"
                  :label="'职位' | dealLanguage('Position')"
                >
                  <Input
                    type="text"
                    v-model="currentForm.title"
                    :placeholder="
                      '请填写职位' | dealLanguage('Please fill in the position')
                    "
                  ></Input>
                </FormItem>
              </Col>
            </Row>
            <FormItem
              prop="addressId"
              :label="'地区' | dealLanguage('Country&City')"
            >
              <div class="ivu-input custom-ipt" @click="handleShowAddress">
                <span class="placeholder-span" v-if="!currentForm.addressId">{{
                  '请选择所在地区' | dealLanguage('Please Select')
                }}</span>
                <span class="txt" v-else>{{
                  currentForm.addressId
                    | addressDtoDeal(
                      addressDtoList,
                      3,
                      '/',
                      language == 'zh' ? 'name' : 'enName',
                    )
                }}</span>
              </div>
            </FormItem>
            <FormItem
              prop="companyProfile"
              :label="'公司性质' | dealLanguage('Company Profile')"
            >
              <RadioGroup
                v-model="currentForm.companyProfile"
                @on-change="handleChangeCompanyProfile"
              >
                <Radio
                  :label="item"
                  v-for="(item, index) in companyProfileList"
                  :key="index"
                ></Radio>
              </RadioGroup>
            </FormItem>
            <FormItem prop="companyprofileother" v-if="companyprofileother">
              <Input
                type="text"
                v-model="currentForm.companyprofileother"
                :placeholder="
                  '其他，请填写' | dealLanguage('Others, please specify')
                "
              ></Input>
            </FormItem>
            <template v-if="$route.name != 'offline'">
              <div class="view-title">
                <div class="title">
                  {{ '参会信息' | dealLanguage('Meeting Registration') }}
                </div>
                <div class="line"></div>
              </div>
              <FormItem
                prop="concurrent2"
                :label="
                  '您需要参加哪些论坛？（多选）'
                    | dealLanguage('Forum Selection (Multiple Choices Available)')
                "
              >
                <CheckboxGroup v-model="currentForm.concurrent2">
                  <!-- <p style="font-weight: 600">{{'9月12日下午' | dealLanguage('On the afternoon of September 12th')}}</p>
                  <Checkbox :label="item" v-for="item,index in concurrentList.slice(0, 5)" :key="index"></Checkbox>
                  <p style="font-weight: 600">{{'9月13日上午' | dealLanguage('On the morning of September 13th')}}</p>
                  <Checkbox :label="item" v-for="item,index in concurrentList.slice(5, 12)" :key="index"></Checkbox>
                  <p style="font-weight: 600">{{'9月13日下午' | dealLanguage('On the afternoon of September 13th')}}</p> -->
                  <Checkbox
                    :label="item"
                    v-for="(item, index) in concurrentList[language]"
                    :key="index"
                  ></Checkbox>
                </CheckboxGroup>
              </FormItem>
              <FormItem
                prop="whether"
                :label="
                  '您是否愿意参加 9月18日2026 龙沙亚太细胞基因治疗创新技术论坛'
                    | dealLanguage(
                      'Would you like to attend 2026 Lonza APAC CGT Innovation Forum - Beijing on September 18, 2026',
                    )
                "
              >
                <div class="tip">
                  {{
                    '本论坛为CSGCT大会会前专场，聚焦细胞与基因治疗从研发到生产的关键技术环节。论坛内容涵盖监管合规策略、大规模电转染基因编辑技术、干细胞与外泌体研究、快速微生物检测等实操方向。名额有限，报满即止！'
                      | dealLanguage(
                        'This forum is a pre-conference session of the CSGCT Congress, focusing on the key technical aspects of cell and gene therapy from R&D to production. The content covers practical directions such as regulatory compliance strategies, large-scale electroporation gene editing technology, stem cell and exosome research, and rapid microbial detection. Limited slots available, registration closes upon reaching capacity!',
                      )
                  }}
                </div>
                <RadioGroup v-model="currentForm.whether">
                  <Radio label="1">{{ '是' | dealLanguage('Yes') }}</Radio>
                  <Radio label="0">{{ '否' | dealLanguage('No') }}</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem
                prop="whether2"
                :label="
                  '您是否有意向与海淀区政府沟通交流（包括项目落地、融资、临床、人才、合作等）？'
                    | dealLanguage(
                      'Do you have any interest in communicating with the Haidian District Government (regarding project launch, financing, clinical trials, talent, cooperation, etc.)?',
                    )
                "
              >
                <div class="tip" v-if="language == 'zh'">
                  近年来，<strong>北京市海淀区政府针对CGT领域出台了系列专项支持政策，从研发平台、临床合作、监管创新、资金支持等多维度赋能产业发展。临床资源方面</strong>，海淀坐拥北医三院、北大肿瘤医院等十余家顶尖三甲医院，为企业开展IIT及临床研究提供了可直接触达的临床合作资源。<strong>人才方面</strong>，海淀依托清华、北大等37所高等院校，构建了从基础研究到药物研发的完整人才链。<strong>产业空间方面</strong>，海淀规划了北部、中部、南部三大专业集聚区，释放200万平方米医药健康产业空间，满足企业从研发到生产不同阶段的空间需求。如您有项目落地、临床合作、融资需求、人才招引等合作意向，我们将在CSGCT大会现场为您对接海淀区相关部门。
                </div>
                <div class="tip" v-else>
                  In recent years, the Haidian District Government of Beijing has
                  rolled out a series of special support policies for the CGT
                  sector, empowering industrial development across multiple
                  dimensions—including R&D platforms, clinical collaboration,
                  regulatory innovation, and financial support. In terms of
                  clinical resources, Haidian is home to more than ten top-tier
                  tertiary hospitals, such as Peking University Third Hospital and
                  Peking University Cancer Hospital, providing enterprises with
                  directly accessible clinical collaboration resources for
                  investigator-initiated trials (IIT) and clinical research. On
                  the talent front, leveraging 37 higher-education institutions
                  including Tsinghua University and Peking University, Haidian has
                  built a complete talent pipeline spanning from basic research to
                  drug development. Regarding industrial space, Haidian has
                  planned three specialized clusters in the northern, central, and
                  southern zones, releasing 2 million square meters of biomedical
                  industrial space to accommodate the needs of enterprises at
                  different stages—from R&D to production. If you have interest in
                  project launch, clinical collaboration, financing needs, talent
                  recruitment, or other cooperation intentions, we will connect
                  you with the relevant Haidian District government departments
                  on-site at the meeting.
                </div>
                <RadioGroup
                  v-model="currentForm.whether2"
                  @on-change="handleChangeWhether2"
                >
                  <Radio label="1">{{ '是' | dealLanguage('Yes') }}</Radio>
                  <Radio label="0">{{ '否' | dealLanguage('No') }}</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem
                prop="whether2content"
                label="交流内容（可多选）"
                v-if="currentForm.whether2 === '1'"
              >
                <CheckboxGroup
                  v-model="currentForm.whether2content"
                  @on-change="handleChangeWhether2Content"
                >
                  <Checkbox
                    label="我希望在海淀落公司/项目，需要政策咨询与专项申报指导"
                  ></Checkbox>
                  <Checkbox
                    label="我希望在海淀落公司/项目，需要产业空间与落地支持"
                  ></Checkbox>
                  <Checkbox
                    label="我希望在海淀落公司/项目，需要产业基金与投融资对接"
                  ></Checkbox>
                  <Checkbox
                    label="我希望与海淀的院校/企业/平台合作，开展项目研发与技术攻关"
                  ></Checkbox>
                  <Checkbox
                    label="我希望与海淀区的三甲医院合作开展IIT或临床研究，需要临床资源与医企对接"
                  ></Checkbox>
                  <Checkbox label="其他"></Checkbox>
                </CheckboxGroup>
                <Input
                  v-if="
                    currentForm.whether2content &&
                      currentForm.whether2content.indexOf('其他') > -1
                  "
                  type="text"
                  v-model="currentForm.whether2other"
                  placeholder="其他，请填写"
                  style="margin-top: 10px;"
                ></Input>
              </FormItem>
              <FormItem
                prop="xs"
                :label="
                  '您是否希望使用CSGCT大会线上1V1配对系统？（CSGCT联盟会员享受免费使用权益，非会员请勾选下方成员权益）'
                    | dealLanguage(
                      'Do you wish to use the CSGCT Congress online 1-on-1 matchmaking system? (CSGCT  members enjoy free access; non-members, please check the membership benefits below.)',
                    )
                "
              >
                <RadioGroup v-model="currentForm.xs" @on-change="handleChangeXs">
                  <Radio label="1">{{ '是' | dealLanguage('Yes') }}</Radio>
                  <Radio label="0">{{ '否' | dealLanguage('No') }}</Radio>
                </RadioGroup>
              </FormItem>
              <div
                class="tip"
                style="margin-bottom: 10px"
                v-if="currentForm.xs == 1 && language == 'zh'"
              >
                （为了能更好地帮助您跟更多海内外参会代表对接，以下信息请填写英文）
              </div>
              <div
                class="xs-form-cols"
                v-if="currentForm.xs == 1 && language == 'zh'"
              >
                <FormItem prop="email2" label="邮箱">
                  <Input
                    type="text"
                    v-model="currentForm.email2"
                    placeholder="请输入您的邮箱"
                  ></Input>
                </FormItem>
                <FormItem prop="company2" label="公司名称">
                  <Input
                    type="text"
                    v-model="currentForm.company2"
                    placeholder="请输入您的公司名称"
                  ></Input>
                </FormItem>
                <FormItem prop="name2" label="姓名">
                  <Input
                    type="text"
                    v-model="currentForm.name2"
                    placeholder="请输入您的姓名"
                  ></Input>
                </FormItem>
                <FormItem prop="position2" label="职务">
                  <Input
                    type="text"
                    v-model="currentForm.position2"
                    placeholder="请输入您的职务"
                  ></Input>
                </FormItem>
              </div>
              <FormItem prop="qnForum">
                <label slot="label">
                  <template v-if="language == 'zh'">
                    为促进中美青年科学家深度交流，CSGCT大会期间将特别举办"中美细胞与基因治疗青年科学家论坛暨对接交流会"。如今感兴趣交流，欢迎报名！本活动为审核制，报名后将有工作人员与您联系，确认参会事宜！
                  </template>
                  <template v-else>
                    To promote in-depth exchanges among young scientists between
                    China and the United States, a special "China-U.S. Young
                    Scientist Forum on Cell and Gene Therapy and Networking
                    Meeting" will be held during the CSGCT Annual Meeting. If you
                    are interested in participating, you are welcome to register!
                    This event operates on an approval basis; after registration,
                    our staff will contact you to confirm your attendance details.
                  </template>
                </label>
                <RadioGroup v-model="currentForm.qnForum">
                  <template v-if="language == 'zh'">
                    <Radio
                      label="A.希望参与，我是美国籍、45岁以下青年科学家"
                    ></Radio>
                    <Radio label="B.希望参与，我是青托获奖者"></Radio>
                    <Radio label="C.希望参与，我是青培人员"></Radio>
                    <Radio label="D.希望参与，以上都不是"></Radio>
                    <Radio label="E.不参与"></Radio>
                  </template>
                  <template v-else>
                    <Radio
                      label="A. I like to participate. I am a U.S. citizen, a young scientist under 45 years of age."
                    ></Radio>
                    <Radio
                      label="B. I would like to participate but do not meet the criteria in Option A."
                    ></Radio>
                    <Radio label="C. I will not participate."></Radio>
                  </template>
                </RadioGroup>
              </FormItem>
            </template>
            <div class="view-title">
              <div class="title">
                {{
                  '请选择门票类型'
                    | dealLanguage('Please select the ticket type')
                }}
              </div>
              <div class="line"></div>
            </div>
            <FormItem prop="activityTicketId">
              <div class="ticket-list">
                <RadioGroup
                  v-model="currentForm.activityTicketId"
                  @on-change="handleSeletTicket"
                >
                  <Radio
                    :label="item.id"
                    v-for="(item, index) in ticketList"
                    :key="index"
                  >
                    <div class="ticket-item ticket-container">
                      <div class="ticket-item-top">
                        <div class="ticket-item-top-left">
                          <img :src="item.activityShareImagePath | logo_show" />
                        </div>
                        <div class="ticket-item-top-right">
                          <div class="title">
                            {{ item.title | dealLanguage(item.enTitle) }}
                          </div>
                          <div class="price-container" v-if="item.price">
                            <div class="lt">
                              <template v-if="channelDiscountRate < 1">
                                <span
                                  class="discount"
                                  v-if="language == 'en'"
                                  >{{
                                    channelDiscountRate | discountShow
                                  }}</span
                                >
                                <span
                                  class="discount"
                                  v-if="language == 'zh'"
                                  >{{
                                    channelDiscountRate | discountShowZh
                                  }}</span
                                >
                              </template>
                            </div>
                            <div class="rt">
                              <span class="price"
                                >{{ '￥' | dealLanguage('$')
                                }}{{ item.price | ticketPrice }}</span
                              >
                              <span
                                class="original-price"
                                v-if="channelDiscountRate < 1"
                                >${{ item.price }}</span
                              >
                              <span
                                class="original-price"
                                v-if="
                                  item.originalPrice &&
                                    channelDiscountRate === 1
                                "
                                >${{ item.originalPrice }}</span
                              >
                            </div>
                          </div>
                          <div class="price-container" v-else>
                            <div class="lt"></div>
                            <div class="rt">
                              <span
                                class="price"
                                v-if="[154, 162].includes(item.id)"
                                >{{
                                  '工作人员会联系您缴费'
                                    | dealLanguage(
                                      'The staff will contact you to make the payment.',
                                    )
                                }}</span
                              >
                              <span class="price" v-else>{{
                                '免费' | dealLanguage('FREE')
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="desc"
                        v-html="item.remark"
                        v-if="item.remark && language == 'zh'"
                      ></div>
                      <div
                        class="desc"
                        v-html="item.enRemark"
                        v-if="item.enRemark && language == 'en'"
                      ></div>
                      <div
                        class="ticket-extra-question"
                        v-if="
                          (item.id == 210 || item.id == 218) &&
                            String(currentForm.activityTicketId) ===
                              String(item.id)
                        "
                        @click.stop
                      >
                        <div class="ticket-extra-question-label">
                          {{
                            '邀请人 / 推荐人（姓名）：'
                              | dealLanguage('Invited / Recommended by (Name):')
                          }}
                        </div>
                        <Input
                          type="text"
                          v-model="currentForm.invitedRecommendedBy"
                          :placeholder="
                            '请填写' | dealLanguage('Please fill in')
                          "
                        ></Input>
                      </div>
                    </div>
                  </Radio>
                </RadioGroup>
              </div>
            </FormItem>
          </Form>
        </div>
      </div>
      <div class="btn-container" v-if="currentTicket.id && canSignUp">
        <div class="info">
          <div class="info-p0" v-if="$route.name != 'offline'">
            {{
              '展会前3天（9月16日0点后）不支持退票'
                | dealLanguage(
                  'Ticket refunds are not available within three days of the exhibition (starting from 00:00 on September 16).',
                )
            }}
          </div>
          <div class="info-p1">
            <template v-if="currentTicket.price">
              <span>{{ '门票价格：' | dealLanguage('Ticket price: ') }}</span>
              <span
                >{{ '￥' | dealLanguage('$')
                }}{{ currentTicket.price | ticketPrice }}</span
              >
            </template>
            <template v-else>
              <span v-if="[154, 162].includes(currentTicket.id)">{{
                '工作人员会联系您缴费'
                  | dealLanguage(
                    'The staff will contact you to make the payment.',
                  )
              }}</span>
              <span v-else>{{ '免费' | dealLanguage('FREE') }}</span>
            </template>
          </div>
          <div class="info-p2" v-if="currentTicket.price">
            {{ '您需支付' | dealLanguage('You need to pay ')
            }}{{ '￥' | dealLanguage('$')
            }}{{ currentTicket.price | ticketPrice
            }}{{
              '用以支付当前门票' | dealLanguage(' for the current ticket.')
            }}
          </div>
          <div class="info-p2" v-else>
            {{ '无需支付' | dealLanguage('No need to pay') }}
          </div>
        </div>
        <div class="btns">
          <div
            :class="['btn', buttonLoading && 'loading']"
            @click="submit"
            :loading="buttonLoading"
            v-if="language == 'zh'"
          >
            <template v-if="!buttonLoading">
              <div class="btn-left" v-if="currentTicket.price">
                <img
                  :src="
                    static_img_url +
                      'pic/wechat-icon.png?v=' +
                      $store.state.imgVersion
                  "
                />
                <span>微信支付</span>
              </div>
              <span v-else>获取门票</span>
            </template>
            <span v-else>Loading</span>
            <Icon type="ios-arrow-forward" />
          </div>
          <div
            :class="['btn', buttonLoading && 'loading']"
            @click="submitEn"
            :loading="buttonLoading"
            v-if="language != 'zh' && !currentTicket.price"
          >
            <span v-if="!buttonLoading">Get ticket now</span>
            <span v-else>Loading</span>
            <Icon type="ios-arrow-forward" />
          </div>
        </div>
        <div
          class="payment-options"
          v-if="language != 'zh'"
          v-show="currentTicket.price"
        >
          <div :class="['payment-option', paymentWay == 1 && 'selected']">
            <div
              class="payment-option__header"
              @click="handleSelectPaymentOption(1)"
            >
              <div class="payment-option__left">
                <div class="payment-option__radio"></div>
                <span class="payment-option__label">Credit/Debit Card</span>
              </div>
              <div class="payment-option__icons">
                <div v-for="(item, index) in Array(2)" :key="index">
                  <img :src="static_img_url + `pic/pay/icon${index + 1}.png`" />
                </div>
              </div>
            </div>
            <div class="payment-option__container" v-show="paymentWay == 1">
              <div class="payment-option__title">
                <h4>Card Details</h4>
                <p>Not available for credit cards issued in Chinese Mainland</p>
              </div>
              <CardPay ref="card-pay" @updateLoading="updateLoading" />
              <Button type="primary" :loading="buttonLoading" @click="submitEn">
                <span v-if="buttonLoading">Generating Order</span>
                <span v-else>PAY ${{ currentTicket.price | ticketPrice }}</span>
              </Button>
            </div>
          </div>
          <div :class="['payment-option', paymentWay == 2 && 'selected']">
            <div
              class="payment-option__header"
              @click="handleSelectPaymentOption(2)"
            >
              <div class="payment-option__left">
                <div class="payment-option__radio"></div>
                <img
                  :src="
                    static_img_url +
                      'pic/paypal-icon.png?v=' +
                      $store.state.imgVersion
                  "
                  class="paypal-logo"
                />
              </div>
              <Button
                type="primary"
                :loading="buttonLoading"
                @click.stop="submitEn"
                v-if="paymentWay == 2"
              >
                <span v-if="buttonLoading">Generating Order</span>
                <span v-else>PAY ${{ currentTicket.price | ticketPrice }}</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div class="closed" v-if="!canSignUp">
        <div>
          {{
            '线上报名已截止，请前往现场报名'
              | dealLanguage(
                'Online registration has closed, please go to the venue to register',
              )
          }}
        </div>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        :default-index="defaultIndex"
        show-toolbar
        :columns="appMobileAreaCodeDtos"
        @confirm="onConfirm"
        @cancel="showPicker = false"
        value-key="name"
      >
        <template #option="item">
          <div>
            +{{ item.mobileAreaCode }} ({{
              item.countryName | dealLanguage(item.countryEnName)
            }})
          </div>
        </template>
      </van-picker>
    </van-popup>
    <van-popup v-model="showAddress" round position="bottom">
      <van-cascader
        v-model="currentAddressDto"
        :title="'请选择所在地区' | dealLanguage('Please Select')"
        :placeholder="'请选择' | dealLanguage('Select')"
        :options="addressDtos"
        :field-names="fieldNames"
        @close="showAddress = false"
        @finish="handleChangeAddress"
      />
    </van-popup>
  </div>
</template>
<script>
import PageHeader from '@/components/mobile/pageHeader.vue'
import Captcha from '@/components/common/captcha'
import TopTip from './topTip'
import { Agetmeta } from '@/service/app'
import {
  vbefGenOrder,
  orderStatus,
  genOpenidByWechatCode,
} from '@/service/vbef'
import buildTree from 'js/buildTree'
import { searchEntity } from 'js/searchEntity'
import { loginCommon } from '@/assets/js/login'
import { signUpMixins } from '@/assets/js/signUpMixins'
import { Auserinfo } from '@/service/app'
import filter from 'js/filter'
export default {
  metaInfo() {
    const title = this.$route.name == 'offline' ?
      filter.dealLanguage('CSGCT现场报名', 'CSGCT On-site Registration') :
      filter.dealLanguage('预注册', 'Pre-registration')
    return {
      title,
    }
  },
  inject: ['login', 'wxShare'],
  mixins: [searchEntity, loginCommon, signUpMixins],
  components: {
    PageHeader,
    TopTip,
    Captcha,
  },
  created() {
    this.Agetmeta()
    this.getTicketList()
  },
  mounted() {
    this.wxShare({
      title: filter.dealLanguage('预注册-CSGCT', 'Pre-registration-CSGCT'),
      linkurl: this.vbef_path + '/signUp',
    })
    if (this.language == 'zh') {
      if (this.isWeixinBrowser) {
        if (!this.$route.query.code && !this.wxCode) {
          let currentHref = `${this.index2_path}/home/wxMiddleware?language=${
            this.language
          }&src=${this.$route.name}`
          currentHref = encodeURIComponent(currentHref)
          let link = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
            this.wxAppId
          }&redirect_uri=${currentHref}&response_type=code&scope=snsapi_base&state=1#wechat_redirect`
          window.location.href = link
          return
        }
        if (this.$route.query.code) {
          this.wxCode = this.$route.query.code
        }
        this.checkAndInitBridge()
      } else {
        if (this.$route.query.pay_status) {
          this.payOrderId = this.$route.query.order_id
          this.orderStatus()
        }
      }
    }
    this.pageLoading = false
  },
  beforeDestroy() {
    clearInterval(this.orderInv)
    // // 组件销毁前，移除事件监听器
    if (document.removeEventListener) {
      document.removeEventListener('WeixinJSBridgeReady', this.onBridgeReady)
    } else if (document.detachEvent) {
      document.detachEvent('WeixinJSBridgeReady', this.onBridgeReady)
      document.detachEvent('onWeixinJSBridgeReady', this.onBridgeReady)
    }
  },
  data() {
    return {
      pageLoading: true,
      buttonLoading: false,
      wxCode: '',
      wxAppId: 'wx93f12cd83e68833d',
      companyNatureTags: [],
      companyNatureTree: [],
      compNTother: '',
      tqList: Array(3).fill(1),
      currentTicket: {},
      showAddress: false,
      orderInv: 0,
      payOrderId: '',
      showPicker: false,
      defaultIndex: 0,
    }
  },
  computed: {
    fieldNames() {
      return {
        text: this.language == 'zh' ? 'name' : 'enName',
        value: 'id',
      }
    },
  },
  methods: {
    handleShowPicker() {
      if (this.isVerifyCode) return
      this.showPicker = true
    },
    handleShowAddress() {
      this.showAddress = true
    },
    onConfirm(item) {
      this.currentForm.mobileAreaCode = item.mobileAreaCode
      this.showPicker = false
    },
    async Agetmeta() {
      let res = await Agetmeta({
        metaNameList: ['addressDtoList'],
      })
      if (res.code != 0) return
      this.$set(this.$data, 'addressDtoList', res.data.addressDtoList)
      const list =
        this.language == 'zh'
          ? res.data.addressDtoList
          : res.data.addressDtoList.filter((a) => a.gpid != 2287)
      this.addressDtos = buildTree(list)
      // this.$set(this.$data, 'companyNatureTags', res.data.companyNatureTags)
      // res.data.companyNatureTags.forEach((tag) => {
      //   tag.label = filter.dealLanguage(tag.name, tag.enName)
      // })
      // const tree = buildTree(res.data.companyNatureTags)
      // this.companyNatureTree = [...tree]
      // this.handleChangeNT(this.currentForm.companyNatureId, 1)
    },
    handleChangeAddress({ selectedOptions }) {
      this.showAddress = false
      this.currentForm.addressId = selectedOptions.length
        ? selectedOptions[selectedOptions.length - 1]['id'] + ''
        : ''
    },
    handleChangeCompanyProfile(value) {
      this.companyprofileother =
        value.indexOf('其他') > -1 ||
        value.indexOf('Other') > -1 ||
        value.indexOf('other') > -1
    },
    handleChangeWhether2(val) {
      if (String(val) !== '1') {
        this.currentForm.whether2content = []
        this.currentForm.whether2other = ''
      }
    },
    handleChangeWhether2Content(val) {
      if (!val || val.indexOf('其他') === -1) {
        this.currentForm.whether2other = ''
      }
    },
    handleChangeXs(val) {
      if (String(val) !== '1') {
        this.currentForm.name2 = ''
        this.currentForm.email2 = ''
        this.currentForm.company2 = ''
        this.currentForm.position2 = ''
      }
    },
    handleSeletTicket(value) {
      let item = this.ticketList.find((a) => a.id === value)
      this.currentTicket = { ...item }
      if (String(value) !== '210' && String(value) !== '218') {
        this.currentForm.invitedRecommendedBy = ''
      }
    },
    async genOpenidByWechatCode() {
      let res = await genOpenidByWechatCode({
        appId: this.wxAppId,
        wechatCode: this.wxCode,
      })
      if (res.code == 0) {
        this.openId = res.data.openId
        const query = { ...this.$route.query }
        if (query.code) {
          delete query.code
          this.$router.replace({ query }).catch((e) => {})
        }
      }
    },
    submit() {
      if (!this.canSignUp) {
        return false
      }
      // console.log(this.currentForm)
      if (this.buttonLoading) return
      // if (!this.user_key) {
      //   this.login(this.ininUserInfo)
      //   return
      // }
      this.$refs['current-form'].validate(async (valid) => {
        if (valid) {
          this.buttonLoading = true

          let { activityTicketId, ...params } = this.currentForm
          let userParams = {
            name: params.name,
            compName: params.compName,
            entityId: params.entityId,
            title: params.title,
          }
          await this.updateUser(userParams)
          let ticketParamsStr = JSON.stringify(params)
          let pay_type =
            this.currentTicket.type == 1 ? 0 : this.isWeixinBrowser ? 1 : 2
          if (pay_type == 2) {
            this.buttonLoading = false
            this.$notify('请到微信中打开后再支付')
            return
          }
          let order = await vbefGenOrder({
            activityTicketId: activityTicketId,
            checkFormJson: ticketParamsStr,
            payType: pay_type,
            loginPlatform: 9,
            openId: pay_type == 1 ? this.openId : '',
          })
          this.buttonLoading = false
          if (order.code == 0) {
            if (pay_type == 1) {
              this.payOrderId = order.data.activityOrderId
              this.invokeWeChatPay(order.data.jsapiResult)
            } else if (pay_type == 0) {
              this.$notify({
                type: 'success',
                message: filter.dealLanguage(
                  '报名成功！',
                  'Registration successful!',
                ),
              })
              this.$router.push({
                name: 'ticketDetail',
                params: { id: order.data.activityTicketUserRelationId },
              })
            }
          } else {
            this.$notify(
              filter.dealLanguage(order.msg, order.enMsg || order.msg),
            )
          }
        } else {
          this.$notify(
            filter.dealLanguage(
              '请完善表单后提交',
              'Please complete the form and submit it',
            ),
          )
        }
      })
    },
    async updateUser(userParams) {
      let res = await Auserinfo(userParams)
      if (res.code == 0) {
        let user = { ...this.user }
        user.name = userParams.name
        user.compName = userParams.compName
        user.entityId = userParams.entityId
        user.title = userParams.title
        this.$store.commit('updateUser', user)
      }
    },
    async orderStatus() {
      let res = await orderStatus({
        id: this.payOrderId,
      })
      if (res.code == 0) {
        if (res.data.status == 2) {
          this.$notify({
            type: 'success',
            message: filter.dealLanguage('购买成功！', 'Purchase successful!'),
          })
          clearInterval(this.orderInv)
          this.$router.push({
            name: 'ticketDetail',
            params: { id: res.data.activityTicketUserRelationId },
          })
        }
      }
    },
    invokeWeChatPay(params) {
      if (
        typeof WeixinJSBridge == 'object' &&
        typeof WeixinJSBridge.invoke == 'function'
      ) {
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest',
          {
            // 这些参数应由后端提供
            appId: this.wxAppId,
            timeStamp: params.timeStamp,
            nonceStr: params.nonceStr,
            package: params.packageValue,
            signType: params.signType, // 或者其他签名方式，如"RSA"
            paySign: params.paySign,
          },
          (res) => this.handlePaymentResponse(res),
        )
      } else {
        // 处理WeixinJSBridge不可用的情况
        console.error('WeixinJSBridge is not available.')
      }
    },
    handlePaymentResponse(res) {
      if (res.err_msg == 'get_brand_wcpay_request:ok') {
        // 支付成功处理逻辑
        this.orderInv = setInterval(() => {
          this.orderStatus()
        }, 1000)
      } else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
        // 支付取消处理逻辑
        this.$notify(filter.dealLanguage('取消支付', 'Cancel payment'))
      } else if (res.err_msg == 'get_brand_wcpay_request:fail') {
        // 支付失败处理逻辑
        this.$notify(
          filter.dealLanguage(
            '支付失败，请重试',
            'Payment failed, please try again',
          ),
        )
      } else {
        // 其他情况处理逻辑
        console.log('Unknown payment response.', res)
      }
    },
    onBridgeReady() {
      // WeixinJSBridge 已经准备好了，可以进行后续操作
      console.log('WeixinJSBridge is ready.')
      // 这里可以调用需要Bridge就绪后才能执行的方法，例如this.invokeWeChatPay()
    },
    checkAndInitBridge() {
      // 微信浏览器
      if (typeof WeixinJSBridge == 'undefined') {
        if (document.addEventListener) {
          document.addEventListener(
            'WeixinJSBridgeReady',
            this.onBridgeReady,
            false,
          )
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady)
          document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady)
        }
      } else {
        this.onBridgeReady()
      }
    },
  },
  watch: {
    companyprofileother() {
      this.currentForm.companyprofileother = ''
    },
  },
}
</script>
<style lang="stylus" scoped>
@import '~styles/common-m.styl'
@import '~styles/form-view-m.styl'
@import '~styles/ticket-item-m.styl'
@import '~styles/sign-up-m.styl'
.tip
  color #999
  line-height 1.5
  font-size 14px
.ticket-extra-question
  margin-top 12px
  padding-top 12px
  border-top 1px solid #f0f0f0
  position relative
  z-index 1

.ticket-extra-question-label
  margin-bottom 8px
  font-size 14px
  line-height 22px
  color #333
.info-p0
  color #FA5151
  margin-bottom 10px
.closed
  padding .4rem
  > div
    font-size: 14px;
    line-height: 1.5;
    background: #999;
    color: #FFF;
    width: fit-content;
    padding: 10px 20px;
    text-align: center;
    border-radius: 6px;
    margin: 0 auto;
    cursor: no-drop;
</style>
